import { render, staticRenderFns } from "./CompanyInstructionTree.vue?vue&type=template&id=50bfa4ac&scoped=true&"
import script from "./CompanyInstructionTree.vue?vue&type=script&lang=js&"
export * from "./CompanyInstructionTree.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInstructionTree.vue?vue&type=style&index=0&id=50bfa4ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfa4ac",
  null
  
)

export default component.exports